





import Vue from 'vue'

export default Vue.extend({
  name: 'ColorCellRenderer',

  computed: {
    cellColor (): string {
      // @ts-ignore
      return this.params.data.color
    }
  }
})
